jQuery(document).ready(function ($) {
  const chat = $('.onereach-chat');
  if(chat.length) {
    $('html').addClass('with-chat');
    let chatOpenOnce = false;
    const chatIframe = chat.find('iframe');
    const closeIcon = chat.find('.onereach-chat__close');

    const chatLink = $('a[href="#onereach-chat"]');
    chatLink.on('click', function(e) {
      e.preventDefault();
      $('html').addClass('chat-active');
      if(!chatOpenOnce) {
        chatOpenOnce = true;
        chatIframe.attr('src', chatIframe.attr('src'));
      }
    });

    closeIcon.on('click', function(e) {
      e.preventDefault();
      $('html').toggleClass('chat-active');
      if(!chatOpenOnce) {
        chatOpenOnce = true;
        chatIframe.attr('src', chatIframe.attr('src'));
      }
    });

    const postToChat = $('.onereach-chat-post');
    const iframeWindow = chatIframe[0].contentWindow;
    postToChat.on('click', function(e) {
      e.preventDefault();
      $('html').addClass('chat-active');
      if(!chatOpenOnce) {
        chatOpenOnce = true;
        chatIframe.attr('src', chatIframe.attr('src'));
      }
      const demoId = $(this).attr('demo-id');
      iframeWindow.postMessage({
        type: 'RUN_GLOBAL_COMMAND',
        payload: {
          name: demoId,
        },
      }, '*');
    });
  }
});